"use client";

import React, { useCallback, useEffect, useRef, useState } from "react"
import styled from "styled-components"
import { OfferService } from "@motorata/base-ui.services.api-service"
import { Title } from "@motorata/base-ui.components.atoms.typography"
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import { SentryService } from "@motorata/base-ui.services.sentry-service";
import OfferBlock, { OfferBlockLoader } from "../../components/shared/OfferBlock"
import FooterSection from "../../components/shared/FooterSection"
import RentSection from "../../components/sections/RentSection"
import AdvantagesSection from "../../components/sections/AdvantagesSection"
import NewsletterSection from "../../components/sections/NewsletterSection"
import { useFavourite } from "../../hooks/useFavourite"
import FinanceTypesSection from "@/components/sections/FinanceTypesSection";

const WatchedOffers = () => {
  const { ids, setIds } = useFavourite()

  const firstUseEffect = useRef(true)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])

  const fetchData = useCallback(async newIds => {
    try {
      setLoading(true)
      const data = await OfferService.getFavouriteOffers(newIds)
      setData(data)
      setIds(data.map(offer => offer.id))
    } catch (e) {
      SentryService.error("[ERROR OfferService.getFavouriteOffers API]", e)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (ids) {
      if (firstUseEffect.current) {
        fetchData(ids)
      }
      firstUseEffect.current = false
    }
  }, [ids])

  return (
    <>
      <Wrapper>
        <Title label="Ulubione" type="primary">Obserwowane ogłoszenia</Title>
        <Content>
          {loading && (
            <div>
              <OfferBlockLoader />
            </div>
          )}
          <Box>
            {!loading &&
              data
                .filter(offer => ids.includes(offer.id))
                .filter(offer => offer.status === "active")
                .map(offer => (
                  <OfferBlock
                    key={offer.id}
                    offer={offer}
                  />
                ))}
          </Box>
          <Box>
            {!loading &&
              data
                .filter(offer => ids.includes(offer.id))
                .filter(offer => offer.status !== "active")
                .map(offer => (
                  <OfferBlock
                    column={false}
                    key={offer.id}
                    offer={offer}
                  />
                ))}
          </Box>
        </Content>
      </Wrapper>
      <FinanceTypesSection />
      <RentSection />
      <FooterSection marginTop="0">
        <AdvantagesSection />
        <NewsletterSection />
      </FooterSection>
    </>
  )
}

export default WatchedOffers

const Content = styled.div`
  > div {
    margin-bottom: 2rem;

    > div {
      margin-bottom: 1rem;
    }
  }
`

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1000px;
`
